/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WebApiEndpointsVisitsUpdateUpdateVisitRequest { 
    contactId?: string | null;
    beginDateTime?: string;
    endDateTime?: string;
    subject?: string | null;
    note?: string | null;
    salesRepresentativeId?: string | null;
}

